import store from '@/helpers/store'

export default (to, from, next) => {
  if (store.getters['auth/authenticated']) {
        next()
  } else {

    store.dispatch('auth/getUserData')
        .then(() => {
              if( localStorage.getItem('user')){
                    next({ path: '/aplicatii/m3-status'})
              }
              else{
                    let utm_param = to && to.redirectedFrom ? to.redirectedFrom : '/';
                    next({ path: '/login' + utm_param })
              }
        })

  }
}
